import {BookItem} from './bookItem';



export type FileStatus = "current" | "past";

export class FileInfo {
  constructor(
    public diff: string,
    public full: string,
    public status: FileStatus,
    public version: string,
    public title: string,
    public titleDiff: string
  ) {};
}


export class IndexItem extends BookItem {

  public files: FileInfo[] = [];
  public currentFile: FileInfo;
  public pastFiles: FileInfo[] = [];
  protected _fileNumber: number = 0;
  public translated: boolean;
  constructor(rawIndexItem: any) {
    super(rawIndexItem);

    if (typeof rawIndexItem.pdf !== 'undefined'
      && Array.isArray(rawIndexItem.pdf)) {
      rawIndexItem.pdf.map(file => this.processRawFile(file));
    }

    this.updateAvailableFileNumber();
  }

  protected processRawFile(rawFile: any): void {
    let file = new FileInfo(
      rawFile.diff,
      rawFile.full,
      rawFile.status,
      rawFile.version,
      this.extractTitleFromFileUrl(rawFile.full),
      this.extractTitleFromFileUrl(rawFile.diff),
    );

    this.files.push(file);

    switch (file.status) {
      case 'current':
        this.currentFile = file;
        break;
      case 'past':
        this.pastFiles.push(file);
        break;
    }
  }

  protected updateAvailableFileNumber() {
    this._fileNumber = 0;
    if (this.currentFile) {
      this._fileNumber = this._fileNumber + (this.currentFile.full ? 1 : 0);
      this._fileNumber = this._fileNumber + (this.currentFile.diff ? 1 : 0);
    }
  }

  protected extractTitleFromFileUrl(url: string): string {
    var title = "";
    if (typeof url === 'string') {
      title = url.substr(url.lastIndexOf('/') + 1);
    }
    return title;
  }

  /**
   * Get item's chapters.
   *
   * Chapters are 'txt' type.
   */
  get chapters(): IndexItem[] {
    return <IndexItem[]> this.getFilteredChildren('txt');
  }

  /**
   * Get item's appendixes.
   *
   * Chapters are 'app' type.
   */
  get appendixes(): IndexItem[] {
    return <IndexItem[]> this.getFilteredChildren('app');
  }

  get numFiles(): number {
    return this._fileNumber;
  }
}
